type Panel = any;
type Response = any;

export interface Track {
  panels: Panel[];
}

export function getResponse(track: Track, name: string, response: string): Response {
  let resp: Response = {}
  try {
    let panel = track.panels.find((p: Panel) => p.name === name) || {}
    if (['value', 'date'].includes(panel.type)) {
      resp = panel.responses[0]
    }
    else {
      resp = panel.responses.find((r: Response) => r.value === response) || {}
    }
  }
  catch (e) {}
  return JSON.parse(JSON.stringify(resp))
}

export function checkResponse(track: Track, name: string, response: string): boolean | undefined {
  let resp: any = false
  try {
    let panel = track.panels.find((p: Panel) => p.name === name) || {}
    resp = panel.responses.find((r: Response) => r.value === response) || {}
    resp = resp.selected
  }
  catch (e) {}
  return resp
}
